/* eslint-disable eslint-comments/disable-enable-pair */
import { CircularProgress, Divider } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';

import starIcon from '../../../../common/images/staking/icon-star.svg';
import type { MovieRound } from '../../../../hooks/movie-voting.hooks';
import { Button } from '../../../core/button';
import { Panel } from '../../panel/Panel.component';
import styles from './CollectRewardsSingleRoundModal.module.css';

interface Props {
  round: MovieRound;
  userStars: string[];
  rewards: string;
  handleClaimRewards: (roundId: string) => Promise<boolean>;
  hideModal: () => void;
  placeInPastRounds?: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    divider: {
      margin: '20px 0',
    },
  }),
);
interface CollectUnclaimedRewardsProps {
  hideModal: () => void;
}

const CollectRewardsSingleRound: React.FC<Props> = ({
  round,
  placeInPastRounds,
  userStars,
  rewards,
  handleClaimRewards,
  hideModal,
}: Props) => {
  const classes = useStyles();
  const [claimingRewards, setClaimingRewards] = useState(false);
  const claimRewardsOnClick = async () => {
    setClaimingRewards(true);
    const result = await handleClaimRewards(round.roundId);
    if (result) {
      hideModal();
      window.location.reload();
    }
    setClaimingRewards(false);
  };

  const rewardsNumber = parseFloat(rewards);
  const userStarsNumber =
    rewardsNumber === 0
      ? 0
      : userStars
          .map(star => parseFloat(star))
          .reduce((total, stars) => total + stars);

  return (
    <Panel
      title={`Round ${placeInPastRounds ?? round.roundId} rewards`}
      className=""
      bodyClassName="flex flex-col justify-center items-center rounded-lg"
      hasExitModalButton={true}
      hideModal={hideModal}
    >
      <img src={starIcon} alt="starIcon" />
      <div className={styles.labels + ' mt-5'}>
        ROUND {placeInPastRounds ?? round.roundId}
      </div>
      <div className={styles.totalStars}>
        {(userStarsNumber + rewardsNumber).toLocaleString()} STARS
      </div>
      <Divider variant="middle" className={classes.divider + ' w-full'} />
      <div className="flex justify-between items-center w-full mb-3">
        <div className={styles.labels}>Your stars</div>
        <div className={styles.subTotalStars}>{userStarsNumber} STARS</div>
      </div>
      <div className="flex justify-between items-center w-full mb-3">
        <div className={styles.labels}>Earned rewards</div>
        <div className={styles.subTotalStars}>{rewardsNumber} STARS</div>
      </div>
      <Button
        onClick={claimRewardsOnClick}
        disabled={claimingRewards}
        className="w-full"
      >
        {claimingRewards ? (
          <CircularProgress style={{ color: 'white' }} />
        ) : (
          'COLLECT REWARDS'
        )}
      </Button>
    </Panel>
  );
};

export const CollectRewardsSingleRoundModal =
  (
    round: MovieRound,
    userStars: string[],
    rewards: string,
    handleClaimRewards: (roundId: string) => Promise<boolean>,
    placeInPastRounds?: string,
  ) =>
  ({ hideModal }: CollectUnclaimedRewardsProps) => {
    return (
      <CollectRewardsSingleRound
        hideModal={hideModal}
        round={round}
        placeInPastRounds={placeInPastRounds}
        userStars={userStars}
        rewards={rewards}
        handleClaimRewards={handleClaimRewards}
      />
    );
  };
